<template>
    <div>
        <v-card flat >
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <b class="bold">
                        Print Receipt
                    </b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="learner_receipt_data != null" class="ma-2 no-display" id="wv_btn" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Both" value="both" color="#0f2027"></v-radio>
                <v-radio label="Office Copy" value="office" color="#0f2027"></v-radio>
                <v-radio label="Student Copy" value="student" color="#0f2027"></v-radio>
            </v-radio-group>
            <div id="document1">
            <v-row v-if="learner_receipt_data != null && radios != 'both'" >
                <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'office'">
                    <v-card class="outer-div">
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><b class="bold">Fee Receipt</b></center>
                                        </td>
                                    </tr>
                                    <tr>
                                       <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" class="trust-logo" width="100" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                        <span v-if="org_basic_data.trust_name"><b class="bold">{{org_basic_data.trust_name}}</b></span><br>
                                                        <span v-if="org_basic_data.school_name"><b class="bold">{{org_basic_data.school_name}} </b></span><br>
                                                        <span v-if="org_basic_data.address">{{org_basic_data.address}}</span><br>                                                    
                                                        <span v-if="org_basic_data.phone">Phone : {{org_basic_data.phone}}</span><br>                                                    
                                                        <span v-if="org_basic_data.email">Email : {{org_basic_data.email}}</span><br>                                                   
                                                        <span v-if="org_basic_data.website">Website : {{org_basic_data.website}}</span>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" class="school-logo" width="100" alt="logo" /></center>
                                            </th>
                                    </tr>
                                    <!--  <tr>
                                        <td colspan="3">PRN No. :: {{learner_receipt_data.registration_number}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Student Name :: {{learner_receipt_data.name}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Receipt No :: <b class="bold">Office Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Batch :: {{learner_receipt_data.ay}} | Stream :: {{learner_receipt_data.stream}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Quota :: {{learner_receipt_data.quota}} | Standard :: {{learner_receipt_data.standard}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            Receipt Date :: {{learner_receipt_data.receipt_date}}
                                        </td>
                                    </tr> -->

                                    <tr>
                                        <td colspan="1"><b class="bold">PRN No. : </b>{{learner_receipt_data.registration_number}}</td>
                                         <td colspan="1"><b class="bold">Student Name : </b>{{learner_receipt_data.name}}</td>
                                         <td colspan="1"><b class="bold">Office Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                    </tr>
                                    <tr>
                                       <td colspan="1"><b class="bold">Fee Details For : </b>{{learner_receipt_data.ay}}</td>
                                       <td colspan="1"><b class="bold">Standard : </b>{{learner_receipt_data.standard}} -  {{learner_receipt_data.division}}</td>
                                        <td colspan="1">
                                            <b class="bold">Receipt Date :  </b>{{learner_receipt_data.receipt_date}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><b class="bold">Fee Type</b></td>
                                        <td><b class="bold"> Fee Amount (Rs.)</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td colspan="2">
                                            {{item.component}}
                                        </td>
                                        <td>{{item.amount}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="3"><b class="bold"> Fine ::</b> Rs. {{learner_receipt_data.fine}}</td>
                                    <!-- <td>
                                        <b class="bold"> Administration Payout :: </b>
                                    </td>-->
                                </tr>
                                <tr>
                                    <td v-if="tenant == 'sbpps'" colspan="3" class="text-left"><b class="bold"> Total Paid Amount ::</b> Rs. {{learner_receipt_data.amount_with_fine}}.00 ( {{learner_receipt_data.amount_with_fine_in_words}} )</td>
                                    <td v-else colspan="3" class="text-left"><b class="bold"> Total Paid Amount ::</b> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{learner_receipt_data.amount_in_words}} )</td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left"><b class="bold"> Payment Mode :: </b> {{learner_receipt_data.payment_mode}}</td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left"><b class="bold"> Payment Details:</b> {{ learner_receipt_data.remark }}</td>
                                </tr>
                               <tr>
                                    <td colspan="3" class="text-right">
                                    <v-col cols="12" md="12" sm="12">
                                        
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right">
                                        <b class="bold">Authorized Signature</b>
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'student'" >
                    <v-card class="outer-div">
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><b class="bold">Fee Receipt</b></center>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" class="trust-logo" width="100" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                        <span v-if="org_basic_data.trust_name"><b class="bold">{{org_basic_data.trust_name}}</b></span><br>
                                                        <span v-if="org_basic_data.school_name"><b class="bold">{{org_basic_data.school_name}} </b></span><br>
                                                        <span v-if="org_basic_data.address">{{org_basic_data.address}}</span><br>                                                    
                                                        <span v-if="org_basic_data.phone">Phone : {{org_basic_data.phone}}</span><br>                                                    
                                                        <span v-if="org_basic_data.email">Email : {{org_basic_data.email}}</span><br>                                                   
                                                        <span v-if="org_basic_data.website">Website : {{org_basic_data.website}}</span>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" class="school-logo" width="100" alt="logo" /></center>
                                            </th>
                                    </tr>
                                     <tr>
                                        <td colspan="1"><b class="bold">PRN No. : </b>{{learner_receipt_data.registration_number}}</td>
                                         <td colspan="1"><b class="bold">Student Name : </b>{{learner_receipt_data.name}}</td>
                                         <td colspan="1"><b class="bold">Student Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                    </tr>
                                    <tr>
                                       <td colspan="1"><b class="bold">Fee Details For : </b>{{learner_receipt_data.ay}}</td>
                                       <td colspan="1"><b class="bold">Standard : </b>{{learner_receipt_data.standard}} -  {{learner_receipt_data.division}}</td>
                                        <td colspan="1">
                                            <b class="bold">Receipt Date :  </b>{{learner_receipt_data.receipt_date}}
                                        </td>
                                    </tr>
                                    <!--  <tr>
                                    <td>PRN No. :: {{learner_receipt_data.registration_number}}</td>
                                    <th colspan="1">Student Name :: {{learner_receipt_data.name}}</td>
                                     <td>Receipt No :: <b class="bold">Student Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                </tr>
                                <tr>
                                    <td>Batch :: {{learner_receipt_data.ay}} | Stream :: {{learner_receipt_data.stream}}</td>
                                    <td>Quota :: {{learner_receipt_data.quota}} |
                                    Standard :: {{learner_receipt_data.standard}}</td>
                                    <td>
                                            Receipt Date :: {{learner_receipt_data.receipt_date}}
                                    </td>
                                </tr> -->
                                    <!--  <tr>
                                        <td colspan="3">PRN No. :: {{learner_receipt_data.registration_number}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Student Name :: {{learner_receipt_data.name}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Receipt No :: <b class="bold">Student Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Batch :: {{learner_receipt_data.ay}} | Stream :: {{learner_receipt_data.stream}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Quota :: {{learner_receipt_data.quota}} | Standard :: {{learner_receipt_data.standard}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            Receipt Date :: {{learner_receipt_data.receipt_date}}
                                        </td>
                                    </tr> -->
                                    <tr>
                                        <td colspan="2"><b class="bold">Fee Type</b></td>
                                        <td><b class="bold"> Fee Amount (Rs.)</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td colspan="2">
                                            {{item.component}}
                                        </td>
                                        <td>{{item.amount}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="3"><b class="bold"> Fine ::</b> Rs. {{learner_receipt_data.fine}}</td>
                                    <!-- <td>
                                        <b class="bold"> Administration Payout :: </b>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td v-if="tenant == 'sbpps'" colspan="3" class="text-left"><b class="bold"> Total Paid Amount ::</b> Rs. {{learner_receipt_data.amount_with_fine}}.00 ( {{learner_receipt_data.amount_with_fine_in_words}} )</td>
                                    <td v-else colspan="3" class="text-left"><b class="bold"> Total Paid Amount ::</b> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{learner_receipt_data.amount_in_words}} )</td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left"><b class="bold"> Payment Mode :: </b> {{learner_receipt_data.payment_mode}}</td>
                                </tr>
                                 <tr>
                                    <td colspan="3" class="text-left"><b class="bold"> Payment Details:</b> {{ learner_receipt_data.remark }}</td>
                                </tr>
                               <tr>
                                    <td colspan="3" class="text-right">
                                    <v-col cols="12" md="12" sm="12">
                                        
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right">
x                                        <b class="bold">Authorized Signature</b>
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="learner_receipt_data != null && radios == 'both'">
                <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                    <v-card class="outer-div">
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><b class="bold">Fee Receipt</b></center>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" class="trust-logo" width="100" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                        <span v-if="org_basic_data.trust_name"><b class="bold">{{org_basic_data.trust_name}}</b></span><br>
                                                        <span v-if="org_basic_data.school_name"><b class="bold">{{org_basic_data.school_name}} </b></span><br>
                                                        <span v-if="org_basic_data.address">{{org_basic_data.address}}</span><br>                                                    
                                                        <span v-if="org_basic_data.phone">Phone : {{org_basic_data.phone}}</span><br>                                                    
                                                        <span v-if="org_basic_data.email">Email : {{org_basic_data.email}}</span><br>                                                   
                                                        <span v-if="org_basic_data.website">Website : {{org_basic_data.website}}</span>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" class="school-logo" width="100" alt="logo" /></center>
                                            </th>
                                    </tr>                                    
                                     <tr>
                                        <td colspan="1"><b class="bold">PRN No. : </b>{{learner_receipt_data.registration_number}}</td>
                                         <td colspan="1"><b class="bold">Student Name : </b>{{learner_receipt_data.name}}</td>
                                         <td colspan="1"><b class="bold">Office Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                    </tr>
                                    <tr>
                                       <td colspan="1"><b class="bold">Fee Details For : </b>{{learner_receipt_data.ay}}</td>
                                       <td colspan="1"><b class="bold">Standard : </b>{{learner_receipt_data.standard}} -  {{learner_receipt_data.division}}</td>
                                        <td colspan="1">
                                            <b class="bold">Receipt Date :  </b>{{learner_receipt_data.receipt_date}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><b class="bold">Fee Type</b></td>
                                        <td><b class="bold"> Fee Amount (Rs.)</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td colspan="2">
                                            {{item.component}}
                                        </td>
                                        <td>{{item.amount}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="3"><b class="bold"> Fine ::</b> Rs. {{learner_receipt_data.fine}}</td>
                                </tr>
                                <tr>
                                    <td v-if="tenant == 'sbpps'" colspan="3" class="text-left"><b class="bold"> Total Paid Amount ::</b> Rs. {{learner_receipt_data.amount_with_fine}}.00 ( {{learner_receipt_data.amount_with_fine_in_words}} )</td>
                                    <td v-else colspan="3" class="text-left"><b class="bold"> Total Paid Amount ::</b> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{learner_receipt_data.amount_in_words}} )</td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left"><b class="bold"> Payment Mode :: </b> {{learner_receipt_data.payment_mode}}</td>
                                </tr>
                                 <tr>
                                    <td colspan="3" class="text-left"><b class="bold"> Payment Details:</b> {{ learner_receipt_data.remark }}</td>
                                </tr>
                               <tr>
                                    <td colspan="3" class="text-right">
                                    <v-col cols="12" md="12" sm="12">
                                        
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right">
                                  
                                        <b class="bold">Authorized Signature</b>
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                    <v-card class="outer-div">
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><b class="bold">Fee Receipt</b></center>
                                        </td>
                                    </tr>
                                    <tr>
                                       <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" class="trust-logo" width="100" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                        <span v-if="org_basic_data.trust_name"><b class="bold">{{org_basic_data.trust_name}}</b></span><br>
                                                        <span v-if="org_basic_data.school_name"><b class="bold">{{org_basic_data.school_name}} </b></span><br>
                                                        <span v-if="org_basic_data.address">{{org_basic_data.address}}</span><br>                                                    
                                                        <span v-if="org_basic_data.phone">Phone : {{org_basic_data.phone}}</span><br>                                                    
                                                        <span v-if="org_basic_data.email">Email : {{org_basic_data.email}}</span><br>                                                   
                                                        <span v-if="org_basic_data.website">Website : {{org_basic_data.website}}</span>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" class="school-logo" width="100" alt="logo" /></center>
                                            </th>
                                    </tr>
                                    <!--
                                <tr>
                                    <td>PRN No. :: {{learner_receipt_data.registration_number}}</td>
                                    <th colspan="1">Student Name :: {{learner_receipt_data.name}}</td>
                                     <td>Receipt No :: <b class="bold">Student Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                </tr>
                                <tr>
                                    <td>Batch :: {{learner_receipt_data.ay}} | Stream :: {{learner_receipt_data.stream}}</td>
                                    <td>Quota :: {{learner_receipt_data.quota}} |
                                    Standard :: {{learner_receipt_data.standard}}</td>
                                    <td>
                                            Receipt Date :: {{learner_receipt_data.receipt_date}}
                                    </td>
                                </tr> -->
                                    <!--  <tr>
                                        <td colspan="3">PRN No. :: {{learner_receipt_data.registration_number}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Student Name :: {{learner_receipt_data.name}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Receipt No :: <b class="bold">Student Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Batch :: {{learner_receipt_data.ay}} | Stream :: {{learner_receipt_data.stream}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Quota :: {{learner_receipt_data.quota}} | Standard :: {{learner_receipt_data.standard}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            Receipt Date :: {{learner_receipt_data.receipt_date}}
                                        </td>
                                    </tr> -->
                                     <tr>
                                        <td colspan="1"><b class="bold">PRN No. : </b>{{learner_receipt_data.registration_number}}</td>
                                         <td colspan="1"><b class="bold">Student Name : </b>{{learner_receipt_data.name}}</td>
                                         <td colspan="1"><b class="bold">Student Copy</b>-{{learner_receipt_data.receipt_no}}</td>
                                    </tr>
                                    <tr>
                                       <td colspan="1"><b class="bold">Fee Details For : </b>{{learner_receipt_data.ay}}</td>
                                       <td colspan="1"><b class="bold">Standard : </b>{{learner_receipt_data.standard}} -  {{learner_receipt_data.division}}</td>
                                        <td colspan="1">
                                            <b class="bold">Receipt Date :  </b>{{learner_receipt_data.receipt_date}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><b class="bold">Fee Type</b></td>
                                        <td><b class="bold"> Fee Amount (Rs.)</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td colspan="2">
                                            {{item.component}}
                                        </td>
                                        <td>{{item.amount}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="3"><b class="bold"> Fine ::</b> Rs. {{learner_receipt_data.fine}}</td>
                                    <!-- <td>
                                        <b class="bold"> Administration Payout :: </b>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td v-if="tenant == 'sbpps'" colspan="3" class="text-left"><b class="bold"> Total Paid Amount ::</b> Rs. {{learner_receipt_data.amount_with_fine}}.00 ( {{learner_receipt_data.amount_with_fine_in_words}} )</td>
                                    <td v-else colspan="3" class="text-left"><b class="bold"> Total Paid Amount ::</b> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{learner_receipt_data.amount_in_words}} )</td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left"><b class="bold"> Payment Mode :: </b> {{learner_receipt_data.payment_mode}}</td>
                                </tr>
                                 <tr>
                                    <td colspan="3" class="text-left"><b class="bold"> Payment Details:</b> {{ learner_receipt_data.remark }}</td>
                                </tr>
                                 <tr>
                                    <td colspan="3" class="text-right">
                                    <v-col cols="12" md="12" sm="12">
                                        
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right">
                                        <b class="bold">Authorized Signature</b>
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        // props: {
        //     receipt_no: String,
        //     registration_no: String,
        //     ay:Number,
        // },
        data() {
            return {
                overlay: false,
                learner_receipt_data: null,
                radios: null,
                receipt_no: null,
                registration_no: null,
                ay: null,
                org_basic_data:[],
                tenant:null
            };
        },
        watch: {
            receipt_no() {
                this.getData();
            },

            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
            this.ay = JSON.parse(this.$session.get("ay"));
            this.registration_no = JSON.parse(this.$session.get("registration_no"));
        },
        mounted() {
            this.getData();
            this.tenant = localStorage.getItem("EPS-tenant")
        },
        methods: {
            print() {
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
            convert(number) {
                var converter = require("number-to-words");
                const string = converter.toWords(number);
                const string1 = string.charAt(0).toUpperCase() + string.slice(1);
                return string1;
            },
            getData() {
                this.overlay = true;
                this.learner_receipt_data = null;
                const formData = {
                    receipt_no: this.receipt_no,
                    registration_no: this.registration_no,
                    ay: this.ay,
                };
                axios
                    .post("/AccountingAndFeesReports/getFeeReceipts", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_receipt_data = res.data.student_receipt_details;
                            this.org_basic_data = res.data.org_basic_data
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    @media print {
        .school-logo{
            width: 130px !important;
            height: 130px !important;
        }
        .trust-logo{
            width: 160px !important;
            height: 130px !important;
        }
        header,footer,nav,date { 
            display: none !important;
        }
        .text-left{
            text-align: left !important;
        }
        .text-right{
            text-align: right !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {           
            size: 25.0in 15.0in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            padding: 0.6rem !important;
            font-size: x-large !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
            font-weight: normal !important;
            font-family: Arial, sans-serif !important;
        }
        .outer-div{
            font-weight: 900 !important;
        }
        .bold{
            font-weight: 600 !important;
        }
    }
</style>
